export default {
  createTitle: 'Create Notification',
  editTitle: 'Edit Notification',
  backButton: 'Return to Messages',
};
